// React Basic and Bootstrap
import React from "react";

//Import Counter Box
import CounterBox from "../Common/CounterBox";

const Counter = () => {
  const counters = [
    { title: "薪酬已经不在繁重", end: 87, postFix: "%" },
    { title: "让企业工资更合规", end: 79, postFix: "%" },
    { title: "更好的成本管控", end: 68, postFix: "%" },
  ];
  return (
    <section className="section bg-light">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-md-8 mt-4 mt-sm-0 pt-2 pt-sm-0">
            <div className="section-title mr-lg-5">
              <h2 className="title mb-4" align="center">
                更安全、更精准也更快速的薪酬核算方式
              </h2>
              <p className="text-muted ma">我们的用户他们这样认为...</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center" id="counter">
          <CounterBox data={counters} />
        </div>
      </div>
    </section>
  );
};

export default Counter;
